import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clades, componentWidth } from "../constants";
import { changeSubregionPositions } from "../redux/reducers/regionHopSlice";
import { changeSliderPosition, changeSliderRepeatSelection, changeSliderGeneSelection, changeSliderWidth, changeSliderMethylationSelection } from "../redux/reducers/sliderSlice";
import formatActionPayload from "../redux/formatActionPayload";

const RegionHop = ({ genomeData, chromosome, startBoundary, endBoundary }) => {
    const dispatch = useDispatch();
    const { geneData, methylationData, genome, repeatData: data, minChromosomePositions, maxChromosomePositions } = genomeData;
    const sliderData = useSelector(state => state.slider.repeatSelection[genome]);
    const secondaryTracks = useSelector(state => state.dashboard.secondaryTrack);

    const [startInput, setStartInput] = useState(startBoundary);
    const [endInput, setEndInput] = useState(endBoundary);

    // so the actual boundaries are what's shown in the form as placeholders
    useEffect(() => {
        setStartInput(startBoundary);
        setEndInput(endBoundary);
    }, [startBoundary, endBoundary]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (event.target.id.indexOf('start') > -1) setStartInput(value);
        else setEndInput(value);
    }

    const grabSelection = (selection, start, end) => {
        let newSelection = [];
        for (let i=0; i<selection.length; i++) {
            let elem = selection[i];
            if (elem.start >= start && elem.end <= end) {
                newSelection.push(elem)
            }
        }
        return newSelection;
    }

    const recalculateSliderPosition = (selection, start) => {
        const last = selection[selection.length-1];
        // get the position of the slider on the screen
        return (start/last.end) * componentWidth;
    }

    const recalculateSliderWidth = (selection, start, end) => {
        const last = selection[selection.length-1];
        // based on the selected elements determine the slider's position on the screen
        const firstElem = (start/last.end) * componentWidth;
        const lastElem = (end/last.end) * componentWidth;
        return lastElem - firstElem;
    }

    const handlePositionSubmission = (event) => {
        event.preventDefault();

        const tempStart = +startInput;
        const tempEnd = +endInput;

        if (!isNaN(tempStart) && !isNaN(tempEnd)) {
            if (tempStart >= 1 && tempEnd <= maxChromosomePositions[chromosome]) {
                if (tempStart < tempEnd) {
                    let temp = {
                        "start": tempStart,
                        "end": tempEnd,
                        "genome": genome
                    }
                    dispatch(changeSubregionPositions(temp));
        
                    setStartInput(tempStart);
                    setEndInput(tempEnd);
    
                    // new postions, so update slider selection, pos and width
                    const newSliderPos = recalculateSliderPosition(data[chromosome], tempStart);
                    let newPos = {"genome": genome, "position": newSliderPos};
                    dispatch(changeSliderPosition(formatActionPayload(genome, newSliderPos)));
    
                    const newSliderWidth = recalculateSliderWidth(data[chromosome], tempStart, tempEnd);
                    let newWidth = {"genome": genome, "width": newSliderWidth};

                    dispatch(changeSliderWidth(formatActionPayload(genome, newSliderWidth)));
    
                    const newSelection = grabSelection(data[chromosome], tempStart, tempEnd);
                    let newData = {"genome": genome, "selection": newSelection};
                    dispatch(changeSliderRepeatSelection(formatActionPayload(genome, newSelection)));
    
                    for (let i=0; i<secondaryTracks.length; i++) {
                        if (secondaryTracks[i] === "GDM") {
                            const newGenes = grabSelection(geneData[chromosome], tempStart, tempEnd);
                            const newGeneData = {"genome": genome, "geneSelection": newGenes};
                            dispatch(changeSliderGeneSelection(formatActionPayload(genome, newGenes)));
                        }
                        else if (secondaryTracks[i] === "METHYLATION") {
                            const newMethylation = grabSelection(methylationData[chromosome], tempStart, tempEnd);
                            const newMethylData = {"genome": genome, "methylationSelection": newMethylation};

                            dispatch(changeSliderMethylationSelection(formatActionPayload(genome, newMethylation)));
                        }
                    }
                }
                else alert("Please enter an end position that's greater than the start position.");
            }
            else alert(`Please enter a number between ${minChromosomePositions[chromosome]} and ${maxChromosomePositions[chromosome]}.`);
        }
        else if (isNaN(tempStart) && !isNaN(tempEnd)) {
            alert("Please enter a valid start value.")
        }
        else if (!isNaN(tempStart) && isNaN(tempEnd)) {
            alert("Please enter a valid end value.")
        }
    }

    return (
        <form>
            <div className="dashboard-container">
                <input id="subregion-window-start"
                    type="text" value={startInput}
                    onChange={handleInputChange}
                    placeholder="Start position ..." />
                <p> to </p>
                <input id="subregion-window-end"
                    type="text" value={endInput}
                    onChange={handleInputChange}
                    placeholder="End position ..." />
                <button className="basic-button jump-button" onClick={handlePositionSubmission}>Go</button>
            </div>

        </form>
    );
};

export default RegionHop;
